import { Embed } from 'semantic-ui-react';

export default Embed;
